import DropDown from "../forms/dropdown/DropDown";

export type FieldProps = {
  name: string;
  label: string;
  paginationLabel?: string;
  options: {
    key: string;
    value: any;
  }[];
};

export type FiltersBarProps = {
  fields: FieldProps[];
  setFilters: (name: string, val: any) => void;
  onLoadMore?: (key: string) => void;
  getFilterValue: (name: string) => any;
  loadingBottomMargin?: number;
  cypressSelector?: string;


};
export default function FiltersBar(props: FiltersBarProps) {
  const {
    fields,
    setFilters,
    getFilterValue,
    onLoadMore = () => { },
    loadingBottomMargin,
    cypressSelector
  } = props;
  return (
    <>
      {fields.map((field, idx) => (
        <DropDown
          key={`${field.name}Filter_${idx}`}
          name={`${field.name}Filter`}
          onBottomReached={() => onLoadMore(field?.paginationLabel!)}
          schema={{}}
          bottomReachedMargin={loadingBottomMargin}
          register={() => { }}
          setValue={(val: any) => setFilters(field.name, val)}
          defaultValue={getFilterValue(field.name)}
          label={field.label}
          placeholder={field.label}
          error={false}
          options={field.options}
          className="w-full"
          cypressSelector={cypressSelector}
        />
      ))}
    </>
  );
}
